export default __webpack_public_path__ + "static/media/contactanos.cffbe9ef.png";